import React, { useState, useEffect } from "react";
import PayrollAttendanceControls from "./PayrollAttendanceControls";
import PayrollLeavesDetailedGrid from "./PayrollLeavesDetailedGrid";
import {
  fetchLeaveDetailed,
  exportLeaveDetailed,
} from "../Api/PayrollAttendanceservice";
import { useAuth } from "../Context/AuthContext";

import "../Styling/PayrollTheme.css";
const PayrollCockpitLeavesDetailed = () => {
  const { user } = useAuth();
  const orgId = user?.organisationId;
  const [filters, setFilters] = useState({
    page: 1,
    pageSize: 100,
  });

  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);

  const handlePageChange = (newPage) =>
    setFilters((prev) => ({ ...prev, page: newPage }));

  useEffect(() => {
    setLoading(true);
    fetchLeaveDetailed(filters, orgId)
      .then((res) => {
        setData(res?.data || []);
        setTotal(res?.totalCount || 0);
      })
      .finally(() => setLoading(false));
  }, [filters, orgId]);

  return (
    <div className="pac-cockpit__page">
      <div className="pac-cockpit__header">
        <h2 className="pac-cockpit__title">
          Payroll Cockpit — Leaves Detailed
        </h2>
        <p className="pac-cockpit__subtitle">
          View and export detailed leave records
        </p>
      </div>

      <PayrollAttendanceControls
        filters={filters}
        setFilters={setFilters}
        hideStatus={true}
        hideMonth={true}
      />

      {loading ? (
        <div className="pac-cockpit__loading">Loading...</div>
      ) : (
        <PayrollLeavesDetailedGrid
          data={data}
          page={filters.page}
          pageSize={filters.pageSize}
          total={total}
          onPageChange={handlePageChange}
          filters={filters}
        />
      )}
      <div className="pac-cockpit__total">
        <strong>Total Records:</strong> {total.toLocaleString()}
      </div>
    </div>
  );
};

export default PayrollCockpitLeavesDetailed;
